import api from '@/plugins/api'
import { inspection as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'inspection'
import notify from '@ananasbear/notify';
import router from '@/router'
import { list as statusesList } from '@/configs/statuses'
import { gceSpecialistCAUserType } from '@/configs/constants'
import { canViewStatement } from '@/configs/helpers'
import { access } from '@/configs/permissions'
import { downloadArchive, downloadBlob } from '@/configs/download'
import { isUsedInspectionRework, requiredInspectionReworkMeasurements } from '@/configs/inspectionRework'

const validateProofResponse = async response => {
  if (response.code !== 403) return requestValidation(response)
  const error = typeof response.data?.json === 'function' ? await response.data.json() : response.data
  if (error?.detail === 'Document must include four certificate attachments.') {
    notify.warning('proofCertificateAttachmentCountError')
  } else if (error?.detail) notify.warning(error.detail)
  return false
}

export default {
  state: () => ({
    dependency: {},
    inspection: {},
    decisionIssue: {},
    decisionIssueRejectId: null,
    certificate: {},
    lightTransmissionMeasurement: [],
    lightMeasurement: {},
    brakeMeasurement: {},
    gasMeasurement: [],
    smokeMeasurement: [],
    noiseMeasurement: {},
    questions: [],
    vehicle: [],
    vehicleHeadlight: [],
    carcassTypes: [],
    proofs: [],
    isLoadFindVehicle: false,
    measurementResult: {},
    showPassMeasurementIndex: null,
    errorDownloadCompliance: false,
    listAttachmentPointsSeatBelt: [
      { value: 3, name: '3' },
      { value: 2, name: '2' },
      { value: 4, name: '2*' }
    ],
    seatPositions: [
      { value: 'L', name: 'Зліва (L)' },
      { value: 'R', name: 'Справа (R)' },
      { value: 'C', name: 'По центру (C)' }
    ],
    carcassBooleanAnswerList: [
      { name: 'Є', value: true },
      { name: 'Нема', value: false }
    ],
    inStock: [
      { name: 'Присутнє', value: true },
      { name: 'Відсутнє', value: false }
    ],
    neutralizerList: [
      { id: 1, name: 'Окислювальний нейтралізатор'},
      { id: 2, name: 'Трикомпонентний нейтралізатор'}
    ],
    equipmentList: [],
    equipment: null,
    inspectionMeasurementResult: null
  }),
  actions: {
    async setInspection (context, data) {
      const response = await api.post(endpoint.inspection, { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getStatement', data.id)
      return { isResult, id: response.data.id }
    },
    async getInspection (context, id) {
      const response = await api.get(endpoint.action(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        const typeUser = context.rootState.profile.profile.type_user
        const statement = context.rootState.statement.statement
        if (typeUser === gceSpecialistCAUserType &&
          (!canViewStatement(typeUser, statement) || Number(response.data.statement) !== Number(statement.id))) {
          context.commit('SET_DATA', { store, state: 'inspection', data: {} })
          return null // Відмова в доступі, на відміну від помилки запиту (false).
        }
        context.commit('SET_DATA', { store, state: 'inspection', data: response.data })
        await context.dispatch('inspectionRework/sync', response.data)
        if (statusesList.inspectionWaitComplianceCompleted === context.state.inspection.status_document &&
          !context.state.questions.length) {
          let timerGetQuestions = 60
          const timer = setInterval(() => {
            timerGetQuestions--
            context.dispatch('getInspectionQuestions', context.state.inspection.id)
            if (context.state.questions.length) {
              clearInterval(timer)
            } else if (!context.state.questions.length && timerGetQuestions === 0) {
              notify.error('errorDownloadCompliance')
              context.commit('SET_DATA', { store, state: 'errorDownloadCompliance', data: true })
              clearInterval(timer)
            }
          }, 800)
        }
      }
      return isResult
    },
    async updateInspection (context, data) {
      const response = await api.patch(endpoint.action(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) context.dispatch('getInspection', data.id)
      return isResult
    },
    async updateInspectionFromFinalization (context, data) {
      const response = await api.put(endpoint.action(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      return { isResult, id: response.data.id }
    },
    async changeInspectionReworkStatus (_context, { id, status }) {
      const response = await api.patch(endpoint.action(id), { body: { status_document: status } })
      return requestValidation(response)
    },
    async getVehicle (context, params) {
      context.commit('SET_DATA', { store, state: 'isLoadFindVehicle', data: true })
      const response = await api.get(endpoint.findVehicle(params))
      if (await requestValidation(response)) {
        await Promise.all(response.data.results.map(async vehicle => {
          let modelObject = context.getters.directoryById('vehicleModel', vehicle.vehicle_model)
          if (!modelObject) modelObject = await context.dispatch('getDirectoryById', {
            endpoint: 'vehicleModel',
            state: 'vehicleModel',
            id: vehicle.vehicle_model
          })

          vehicle.vehicleMarkAndModel =
            `${ context.getters.directoryById('vehicleMark', modelObject.vehicle_mark)?.name }
            ${ modelObject.name }`
        }))

        context.commit('SET_DATA', { store, state: 'vehicle', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoadFindVehicle', data: false })
    },
    async getVehicleHeadlight (context, id) {
      const response = await api.get(endpoint.getVehicleHeadlight(id))
      const isResult = await requestValidation(response)
      if (isResult) context.commit('SET_DATA', { store, state: 'vehicleHeadlight', data: response.data })
      return isResult
    },
    async setInspectionSign (context, payload) {
      const response = await api.post(endpoint.signCompliance, { body: { document: payload.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspection', response.data.document)
        if (payload.isGetDecisionIssue) await context.dispatch('getDecisionIssue', response.data.document)
      }
      return isResult
    },
    async approveInspectionProtocol (context, id) {
      const response = await api.post(endpoint.approveInspectionProtocol(id))
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getInspection', id)
      return isResult
    },
    async getInspectionSignData (context, id) {
      const response = await api.post(endpoint.inspectionSignData(id))
      return await requestValidation(response) ? response.data : null
    },
    async verifyInspectionSignature (context, payload) {
      const response = await api.post(endpoint.verifyInspectionSignature(payload.id))
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspection', payload.id)
        if (payload.isGetDecisionIssue) await context.dispatch('getDecisionIssue', payload.id)
      }
      return isResult
    },
    async getInspectionProtocolPDF (context, id) {
      const response = await api.get(endpoint.inspectionProtocolPdf(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    async sendInspectionForSignature (_context, id) {
      const response = await api.post(endpoint.sendForSignature(id))
      return await validateProofResponse(response) && response.data?.status === 'success'
    },
    async refreshInspectionSubmission (context, { id, statementId, regenerateProtocol = false }) {
      if (!await context.dispatch('getInspection', id)) return false
      const signatureStatuses = [statusesList.inspectionWitSignatureLabExpert]
      // Keep the primary flow's existing check; rework also accepts progress by other signers.
      if (regenerateProtocol) signatureStatuses.push(statusesList.inspectionWitSignatureLabChief,
        statusesList.inspectionWaitForDecision, statusesList.inspectionIssueCertificate, statusesList.inspectionRejected)
      if (!signatureStatuses.includes(context.state.inspection.status_document)) return false
      // Regenerate only rework protocols that have not already advanced to approval/signing.
      if (regenerateProtocol && context.state.inspection.status_document === statusesList.inspectionWitSignatureLabExpert) {
        if (!await context.dispatch('getInspectionProtocolPDF', id)) return false
        if (!await context.dispatch('getInspection', id) ||
          !signatureStatuses.includes(context.state.inspection.status_document)) return false
      }
      return !!await context.dispatch('getStatement', statementId)
    },
    async downloadSignedInspectionDocument (context, id) {
      const response = await api.get(endpoint.downloadSignedInspectionDocument(id), { responseType: 'blob' })
      if (!await requestValidation(response)) return false

      downloadBlob(response, `inspection-${ id }-signed.zip`)
      return true
    },
    // dependency fields for inspection
    async getDependency (context, statementID) {
      const response = await api.get(endpoint.dependency(statementID))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'dependency', data: response.data })
      }
    },
    // inspection compliance for inspection protocol
    async getInspectionQuestions (context, id) {
      const response = await api.get(`${ endpoint.legalActQuestions(id) }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'questions', data: response.data })
      }
      return isResult
    },
    async getInspectionInconsistenciesQuestions (context, id) {
      const response = await api.get(endpoint.inconsistency(id))
      const isResult = await requestValidation(response)
      return isResult ? response.data : []
    },
    async updateInspectionInconsistenciesQuestions (context, payload) {
      const response = await api.patch(endpoint.inconsistencyAction(
        payload.id, payload.discrepancyId),
        { body: payload.body }
      )
      return await requestValidation(response)
    },
    async setInspectionAnswers (context, data) {
      const response = await api.patch(endpoint.questionsActions(data.inspectionID), { body: data.body })
      return await requestValidation(response)
    },
    async getDecisionLegalActs (context, id) {
      const response = await api.get(`${ endpoint.decisionLegalActs(id) }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'questions', data: response.data.results })
      }
      return isResult
    },
    async setDecisionLegalAct (context, data) {
      const response = await api.patch(
        endpoint.setDecisionLegalAct(context.state.decisionIssue.id, data.id),
        { body: data }
      )
      const isResult = await requestValidation(response)
      if (isResult) {
        setTimeout(async () => {
          await context.dispatch('getDecisionIssue', context.state.inspection.id)
          await context.dispatch('getInspection', context.state.inspection.id)
        }, 1000)
      }
      return isResult
    },
    // measurements
    async saveInspectionReworkMeasurement (context, { id, type, body }) {
      const descriptors = {
        lightTransmission: {
          read: endpoint.getLightTransmission, state: 'lightTransmissionMeasurement', key: 'window',
          update: item => endpoint.updateLightTransmission(id, item.id), create: endpoint.setLightTransmission
        },
        gas: {
          read: endpoint.getGas, state: 'gasMeasurement', key: 'exhaust_system_number', create: endpoint.setGas,
          update: item => endpoint.updateGas({ typeInspection: 'inspection/vehicle_inspection', id, gasId: item.id })
        },
        smoke: {
          read: endpoint.getSmoke, state: 'smokeMeasurement', key: 'exhaust_system_number', create: endpoint.setSmoke,
          update: item => endpoint.updateSmoke({ typeInspection: 'inspection/vehicle_inspection', id, smokeId: item.id })
        },
        brake: { state: 'brakeMeasurement', endpoint: endpoint.brake },
        light: { state: 'lightMeasurement', endpoint: endpoint.light },
        noise: { state: 'noiseMeasurement', endpoint: endpoint.noise }
      }
      const descriptor = descriptors[type]
      if (!descriptor || !isUsedInspectionRework(context.rootState.statement.statement, context.state.inspection) ||
        context.state.inspection.status_document !== statusesList.inspectionWaitComplianceCompleted ||
        String(id) !== String(context.rootState.inspectionRework.id) ||
        context.rootState.inspectionRework.stage !== 'measurements') return false
      if (descriptor.key && (!Array.isArray(body) || !body.length)) return false
      const key = item => String(item[descriptor.key]?.id ?? item[descriptor.key])
      context.commit('inspectionRework/invalidateMeasurement', type)
      const refresh = async () => {
        const response = await api.get(`${(descriptor.read || descriptor.endpoint)(id)}?page_size=100`)
        if (!descriptor.key && response.code === 404) {
          context.commit('SET_DATA', { store, state: descriptor.state, data: {} })
          return true
        }
        if (!await requestValidation(response) || response.data.next) return false
        const data = descriptor.key ? (response.data.results || response.data) : response.data
        if (descriptor.key && !Array.isArray(data)) return false
        context.commit('SET_DATA', { store, state: descriptor.state, data })
        return true
      }
      let confirmed = false
      try {
        // Read again before upserting, including after a partially failed bulk save.
        if (!await refresh()) return false
        const existing = context.state[descriptor.state]
        if (descriptor.key) {
          // Obsolete groups belong to the backend. Only upsert the current form's rows.
          const newRows = []
          for (const row of body) {
            let saved
            if (row.id != null) {
              saved = existing.find(item => String(item.id) === String(row.id))
              if (!saved || key(saved) !== key(row)) return false
            } else {
              const matches = existing.filter(item => key(item) === key(row))
              if (matches.length > 1) return false
              saved = matches[0]
            }
            const clean = { ...row }
            delete clean.id
            if (saved) {
              if (!await requestValidation(await api.patch(descriptor.update(saved), { body: clean }))) return false
            } else {
              if (type === 'lightTransmission') {
                const window = context.state.inspection.vehicle_inspection_windows
                  .find(item => String(item.id) === key(row))
                if (!window) return false
                clean.window_type = window.window_type
                clean.in_driver_overview = window.in_driver_overview
              }
              newRows.push(clean)
            }
          }
          if (newRows.length) {
            const response = await api.post(descriptor.create(id), { body: newRows })
            if (!await requestValidation(response)) return false
          }
        } else {
          const method = existing.id ? 'patch' : 'post'
          const clean = { ...body }
          delete clean.id
          if (!await requestValidation(await api[method](descriptor.endpoint(id), { body: clean }))) return false
        }
        if (!await refresh()) return false
        if (!await context.dispatch('getInspection', id) ||
          !isUsedInspectionRework(context.rootState.statement.statement, context.state.inspection) ||
          context.state.inspection.status_document !== statusesList.inspectionWaitComplianceCompleted) return false
        const allMeasurementsConfirmed = requiredInspectionReworkMeasurements(
          context.state.inspection, context.rootState.statement.statement)
          .every(measurement => measurement === type ||
            context.rootState.inspectionRework.measurements.includes(measurement))
        if (allMeasurementsConfirmed) {
          if (!await context.dispatch('getInspectionQuestions', id)) return false
          context.commit('SET_DATA', { store, state: 'errorDownloadCompliance', data: false })
        }
        context.commit('inspectionRework/confirmMeasurement', type)
        if (allMeasurementsConfirmed) context.commit('inspectionRework/setStage', 'compliance')
        confirmed = true
        return true
      } catch (error) {
        return false
      } finally {
        // Refresh even after partial failure so a retry does not recreate saved rows.
        if (!confirmed) {
          try {
            await refresh()
            await context.dispatch('getInspection', id)
          } catch (error) { /* A later retry starts with a fresh GET. */ }
        }
      }
    },
    async getLightTransmissionMeasurement (context, id) {
      const response = await api.get(endpoint.getLightTransmission(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightTransmissionMeasurement (context, data) {
      const response = await api.post(endpoint.setLightTransmission(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getBrakeMeasurement (context, id) {
      const response = await api.get(endpoint.brake(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
      }
      return isResult
    },
    async setBrakeMeasurement (context, data) {
      const response = await api.post(endpoint.brake(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getLightMeasurement (context, id) {
      const response = await api.get(endpoint.light(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightMeasurement (context, data) {
      const response = await api.post(endpoint.light(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getGasMeasurement (context, id) {
      const response = await api.get(endpoint.getGas(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setGasMeasurement (context, data) {
      const response = await api.post(endpoint.setGas(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getSmokeMeasurement (context, id) {
      const response = await api.get(endpoint.getSmoke(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setSmokeMeasurement (context, data) {
      const response = await api.post(endpoint.setSmoke(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getNoiseMeasurement (context, id) {
      const response = await api.get(endpoint.noise(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
      }
      return isResult
    },
    async setNoiseMeasurement (context, data) {
      const response = await api.post(endpoint.noise(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getProofs (context, id) {
      let query = '?page_size=100'
      const seen = new Set()
      const results = []
      while (query) {
        if (seen.has(query)) return false
        seen.add(query)
        const response = await api.get(`${endpoint.proof(id)}${query}`)
        if (!await requestValidation(response)) return false
        results.push(...response.data.results)
        // Only use pagination parameters; all requests stay on this inspection's endpoint.
        query = response.data.next ? `?${response.data.next.split('?')[1]}` : null
      }
      context.commit('SET_DATA', { store, state: 'proofs', data: { count: results.length, next: null, results } })
      return true
    },
    async downloadInspectionProofFiles (_context, id) {
      return downloadArchive(endpoint.downloadProofFiles(id), `inspection-${ id }-proofs.zip`)
    },
    async deleteInspectionProof (context, { id, proofId }) {
      if (!await validateProofResponse(await api.delete(endpoint.deleteProof(id, proofId)))) return false
      const proofs = context.state.proofs
      if (String(context.state.inspection.id) === String(id) && Array.isArray(proofs.results)) {
        const results = proofs.results.filter(proof => String(proof.id) !== String(proofId))
        // Keep every viewer current even if another deletion or a later upload fails.
        context.commit('SET_DATA', { store, state: 'proofs', data: { ...proofs, count: results.length, results } })
      }
      return true
    },
    async uploadInspectionProofFiles (_context, { id, files, content_type, field_name, file_type }) {
      if (file_type === 'certificate_attachment' && files.length !== 4) {
        notify.warning('proofCertificateAttachmentCountError')
        return false
      }
      // Certificate photos form one batch; additional photos use batches of up to four.
      for (let offset = 0; offset < files.length; offset += 4) {
        const body = new FormData()
        for (const file of files.slice(offset, offset + 4)) body.append('files', file)
        body.append('content_type', content_type)
        if (field_name) body.append('field_name', field_name)
        if (file_type) body.append('file_type', file_type)
        // Finish each request before starting the next batch; stop on the first failure.
        if (!await validateProofResponse(await api.post(endpoint.uploadProofFiles(id), { body }))) return false
      }
      return true
    },
    // Decision Issue
    async getDecisionIssue (context, id) {
      const response = await api.get(`${ endpoint.decisionIssue }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'decisionIssue', data: response.data.results[0] })
      }
      return isResult
    },
    async getDecisionIssueId (context, id) {
      const response = await api.get(`${ endpoint.decisionIssue }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'decisionIssueRejectId', data: response.data.results[0].id })
      }
      return isResult
    },
    async setDecisionIssueSign (context, data) {
      const response = await api.post(endpoint.decisionIssueSign, { body: { document: data.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        //because celery give data
        setTimeout(async () => {
          await context.dispatch('getInspection', data.inspectionID)
          if (context.state.inspection.status_document === statusesList.inspectionRejected) {
            context.commit('SET_DATA', { store, state: 'decisionIssue', data: {} })
          } else {
            await context.dispatch('getDecisionIssue', data.inspectionID)
          }
          await context.dispatch('getCertificate', data.inspectionID)
        }, 1000)
      }
      return isResult
    },
    async getDecisionIssuingPDF (context, id) {
      const response = await api.get(endpoint.pdfDecisionIssuing(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    // certificate
    async getCertificate (context, id) {
      const response = await api.get(`${ endpoint.certificate }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', {
          store,
          state: 'certificate',
          data: response.data.results[0] === undefined ? {} : response.data.results[0]
        })
      }
      return isResult
    },
    async sendToFinalizationInspection (context, body) {
      const response = await api.patch(endpoint.decisionIssueAction(body.id), { body: body.payload })
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getDecisionIssue', body.inspectionID)
      await context.dispatch('getInspection', body.inspectionID)
      return isResult
    },
    async addNoteForCertificate (context, body) {
      const response = await api.patch(endpoint.decisionIssueAction(body.id), { body: body.payload })
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getDecisionIssue', body.inspectionID)
      return isResult
    },
    async setCertificate (context, data) {
      const response = await api.patch(`${ endpoint.certificate }${ data.certificateId }/`,
        { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getCertificate', data.inspectionID)
        await context.dispatch('getDecisionIssue', data.inspectionID)
        await context.dispatch('getInspection', data.inspectionID)
      }
      return isResult
    },
    async setCertificateDsbtTransfer (context, data) {
      const permission = data.transferred === true
        ? 'transferCertificateToDsbt'
        : 'revokeCertificateDsbtTransfer'
      if (typeof data.transferred !== 'boolean' || !access(permission)) {
        return { updated: false, certificateRefreshed: false }
      }
      const response = await api.post(endpoint.certificateDsbtTransfer(data.certificateId), {
        body: { transferred_to_transport_service: data.transferred }
      })
      const isResult = await requestValidation(response)
      if (!isResult) return { updated: false, certificateRefreshed: false }

      const [certificateResult] = await Promise.allSettled([
        context.dispatch('getCertificate', data.inspectionId),
        context.dispatch('getStatement', data.statementId)
      ])
      return {
        updated: true,
        certificateRefreshed: certificateResult.status === 'fulfilled' && certificateResult.value === true
      }
    },
    async setCertificateSign (context, data) {
      const response = await api.post(endpoint.certificateSign, { body: { document: data.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        const responseAppendix = await api.post(endpoint.certificateAppendixSign, { body: { document: data.appendixID }})
        const isResultAppendix = await requestValidation(responseAppendix)
        if (isResultAppendix) {
          // Wait for Celery to update the signed documents.
          await new Promise(resolve => setTimeout(resolve, 700))
          await context.dispatch('getCertificate', data.inspectionID)
          await context.dispatch('getDecisionIssue', data.inspectionID)
          await context.dispatch('getInspection', data.inspectionID)
          await context.dispatch('getStatement', data.statementID)
        }

      }
      return isResult
    },
    async getCertificateSignData (context, id) {
      const response = await api.post(endpoint.certificateSignData(id))
      return await requestValidation(response) ? response.data : null
    },
    async verifyCertificateSignature (context, data) {
      const response = await api.post(endpoint.verifyCertificateSignature(data.id))
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getCertificate', data.inspectionID)
        await context.dispatch('getDecisionIssue', data.inspectionID)
        await context.dispatch('getInspection', data.inspectionID)
        await context.dispatch('getStatement', data.statementID)
      }
      return isResult
    },
    async getCertificatePDF (context, id) {
      const response = await api.get(endpoint.pdfCertificate(id), { responseType: 'blob' })
      if (await requestValidation(response)) return URL.createObjectURL(response.data)
      return false
    },
    async downloadSignedCertificateDocument (context, id) {
      const response = await api.get(endpoint.downloadSignedCertificateDocument(id), { responseType: 'blob' })
      if (!await requestValidation(response)) return false

      downloadBlob(response, `certificate-${ id }-signed.zip`)
      return true
    },
    async getCertificateAppendixPDF (context, id) {
      const response = await api.get(endpoint.pdfCertificateAppendix(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    async getMeasurementResult (context, id) {
      const response = await api.get(endpoint.measurementResult(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'measurementResult', data: response.data })
      }
    },
    setShowPassedMeasurement (context, data) {
      context.commit('SET_DATA', { store, state: 'showPassMeasurementIndex', data: data })
    },
    async getCarcassTypesByCategory (context, id) {
      const response = await api.get(endpoint.getCarcassTypesByCategory(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'carcassTypes', data: response.data })
      }
      return isResult
    },
    async inspectionChangeResponsiblePerson (context, payload) {
      const response = await api.patch(endpoint.inspectionChangeResponsiblePerson(payload.inspectionId),
        { body: payload.assignedTo })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getInspection', payload.inspectionId)
      return isResult
    },
    async getMeasurementEquipmentList (context, data) {
      const response = await api.get(endpoint.equipmentList({ number: data.number, type: data.type }))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'equipmentList', data: response.data })
      }
      return response.data
    },
    async getInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.get(endpoint.measurementInfo(params))
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.get(endpoint.measurementInfoOTK(params))
      }

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionMeasurementResult', data: response.data })
        return response.data
      }
    },
    async saveInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.post(endpoint.measurementInfo(params), { body: data.body })
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.post(endpoint.measurementInfoOTK(params), { body: data.body })
      }

      if (await requestValidation(response)) {
        return response.data
      }
    },
    async updateInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.patch(endpoint.measurementInfo(params), {body: data.body})
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.patch(endpoint.measurementInfoOTK(params), {body: data.body})
      }
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionMeasurementResult', data: response.data })
        return response.data
      }
    },
    async startMeasurementZigBee (context, params) {
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.post(endpoint.startMeasurementLightZigBee(params))
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.post(endpoint.startMeasurementLightZigBeeOTK(params))
      }

      if (response && await requestValidation(response)) {
        return response
      } else {
        if (response?.code === 400) context.dispatch('getEquipmentsList', { type_inspection: 'light' })
        return false
      }
    },
    async terminateInspectionMeasurement (context, id) {
      let response = await api.post(endpoint.terminateInspection(id))
      if (response && await requestValidation(response)) {
        return response
      }
    },
    async sendCertificateToUAS (context, body) {
      const response = await api.get(endpoint.sendCertificateToUAS(body.certificateId))
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getCertificate', body.inspectionId)
      return isResult
    },
    // Ручний номер протоколу вимкнено: відповідний ендпоінт видалено на беці.
    // async addManualInspectionProtocolNumber (context, payload) {
    //   const response = await api.patch(endpoint.addInspectionProtocolNumber(payload.inspectionId), { body: payload.body })
    //   const isResult = await requestValidation(response)
    //   return isResult ? response.data : isResult
    // },
    async updateManualCertificationNumber (context, payload) {
      const response = await api.patch(endpoint.manualCertificationNumber(payload.certificateId), { body: payload.body })
      const isResult = await requestValidation(response)
      return isResult ? response.data : isResult
    }
  }
}
